import { render, staticRenderFns } from "./GCheckListDetail.vue?vue&type=template&id=ca5e494a&scoped=true&"
import script from "./GCheckListDetail.vue?vue&type=script&lang=ts&"
export * from "./GCheckListDetail.vue?vue&type=script&lang=ts&"
import style0 from "./GCheckListDetail.vue?vue&type=style&index=0&id=ca5e494a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca5e494a",
  null
  
)

export default component.exports